import PersonalIcon from '../../../images/personal-icon.svg';
import QueriesImg from '../../../images/queries-1.png';
import * as Styled from '../LegalPages/LegalStyles';
import FooterNav from '../../components/FooterNav/FooterNav';
import {Container, Row} from 'react-bootstrap';
import Navigation from '../../components/Navigation/Navigation';
import Meta from '../../components/Meta/Meta';

const HowItWorksPage = () => {
  return (
    <section>
      <Meta page="howitworks" />
      <Navigation logoText />
      <Container fluid="lg">
        <Row>
          <Styled.PageWrapper>
            <Styled.Heading>
              <Styled.Img src={PersonalIcon} />
            </Styled.Heading>
            <Styled.H4>
              Search algorithms that think like you
            </Styled.H4>
            <Styled.Paragraph>
              We are digitally flooded by emails, Slack messages, links, text messages, files, all the stuff that keeps us connected in our daily lives across different communication platforms. Information is scattered all over. Sometimes it is hard to remember where things are. That’s where Trova comes in. Trova will find the information for you.
            </Styled.Paragraph>
            <Styled.Paragraph>
              While web search was designed for commands, keywords, and phrases, Trova was  created to understand natural human language and to enable conversational search. For example, we type  "café, latte, Chicago'' on a web search engine when we need to search for "a good place to go for a latte in Chicago." As human beings, we search by making connections and asking questions. It is time to establish a connection with our search engine. Why not try asking Trova, "where is that latte place Holly recommended?" There is a good chance that Nina sent the details over email or text message. Trova will find it for you.
            </Styled.Paragraph>
            <Styled.Paragraph>
              Trova further enables smart, fast, human search by using AI to expand the search phrase. For example, when looking for an “autonomous car” concept. Trova also returns the emails that contain “self-driving vehicles.”
            </Styled.Paragraph>
            <Styled.Paragraph>
              Trova learns from you and thinks like you by delivering the most relevant answers faster and in formats that are most helpful to quickly obtain the information you need. Our team of engineers and scientists are  working hard to train our algorithms to upscale your personal searching experience.
            </Styled.Paragraph>
            <Styled.H4>
              How Trova search works
            </Styled.H4>
            <Styled.Paragraph>
              Trova’s T-intent and T-rank are designed to sort the most relevant results for you. Our algorithms look at many factors to deliver the most relevant results. These include the words of your query (i.e. "café, latte, Chicago"), the intent of your query (i.e. finding latte in a café in Chicago), information category (file/link/etc.), relevancy, and the quality of content. In addition, we built a natural language processing (NLP) model to understand what you are looking for, including synonyms.
            </Styled.Paragraph>
            <Styled.CenteredImageContainer>
              <Styled.Img src={QueriesImg} />
            </Styled.CenteredImageContainer>
            <Styled.Paragraph>
              Trova's T-rank analyzes the relevancy of the results when your emails or messages contain the exact keywords or concept as your search query.
            </Styled.Paragraph>
            <Styled.H4>
              Organizing your archive without depriving privacy
            </Styled.H4>
            <Styled.Paragraph>
              Trova does not store your actual messages, files, and links. With your permission, Trova’s search engine will create a rich index of connected apps. This index is non-human readable, encoding information generated by our AI algorithms. Once we process your content, we delete it from our servers, keeping only the rich index for faster processing in the future.
            </Styled.Paragraph>
            <Styled.H4>
              Data protection comes first
            </Styled.H4>
            <Styled.Paragraph>
              We take your data security as our top priority at Trova. We aim to be transparent and open about handling your information security to build mutual trust.  All user information is fully encrypted using the latest industry standards. We also follow industry best practices like GDPR, SOC2, and Privacy Shield. Please read details in <a href="/security">Security practices</a>.
            </Styled.Paragraph>
            <Styled.H4>
              Always improving your experience
            </Styled.H4>
            <Styled.Paragraph>
              Our goal is always to provide you with the most useful and relevant information to answer your search. We know the search can always be better. We spend most of our time testing and training our AI to think like you and deliver the information you are looking for. These tests include internal and external search quality tests, usability tests, and result presentation tests. We also actively invite our users to provide feedback to improve the searching performance. If you would like to participate in our testing, please <a href="mailto:info@gotrova.ai" >reach out to us</a>.
            </Styled.Paragraph>
          </Styled.PageWrapper>
        </Row>
      </Container>
      <FooterNav />
    </section>
  )
}

export default HowItWorksPage;